import { Button, Typography, Box, Stack, Divider, Card, CardContent, IconButton } from '@mui/material'
import { ReactComponent as Child } from '@assets/images/icon/ico_child.svg'
import { ReactComponent as People } from '@assets/images/icon/ico_people.svg'
import { ReactComponent as Foreigner } from '@assets/images/icon/ico_foreigner.svg'
import { useIsMobile } from '@/hooks/Responsive'

// 카카오 아이콘
function KakaoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path d="M8.00005 0C3.5815 0 0 2.76707 0 6.17981C0 8.30224 1.38525 10.1733 3.4947 11.2862L2.60715 14.5284C2.52873 14.8149 2.85638 15.0433 3.10798 14.8773L6.99856 12.3095C7.32688 12.3412 7.66054 12.3597 8.00005 12.3597C12.4182 12.3597 16 9.59272 16 6.17981C16 2.76707 12.4182 0 8.00005 0Z" fill="black"/>
    </svg>
  )
}
// 네이버 아이콘
function NaverIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M10.8491 8.56267L4.91687 0H0V16H5.15088V7.436L11.0831 16H16V0H10.8491V8.56267Z" fill="white"/>
    </svg>
  )
}
// Google 아이콘
function GoogleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
    </svg>
  )
}

export default function Step1({ onNext, MemberKind, snsAuth }) {
  const { isMobile } = useIsMobile()
  
  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 1.5 }}>
        회원유형선택
      </Typography>
      <Typography component="p" variant={isMobile ? 'body1' : 'subtitle2'} fontWeight={400} sx={{ mb: isMobile ? 4 : 6 }}>
        회원 유형에 따라 가입 절차가 다릅니다. 본인에게 해당하는 유형을 선택해 주세요.
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={3}
        sx={{ mb: 1.5 }}
      >
        {/* 만 14세 미만 회원 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
            minHeight: isMobile ? 'auto' : '304px',
          }}
        >
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 3,
            }}
          >
            <Box sx={{ pt: isMobile ? 0 : 4, textAlign: 'center', mb: isMobile ? 3 : 0 }}>
              <Box
                component={Child}
                sx={{
                  width: '48px',
                  height: '48px',
                  mb: isMobile ? 1 : 3,
                }}
              />
              <Typography fontWeight={500}>만 14세 미만 회원</Typography>
            </Box>
            <Button variant="contained" fullWidth onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); onNext(MemberKind.G14D); }}>가입하기</Button>
          </CardContent>
        </Card>

        {/* 만 14세 이상 회원 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
            minHeight: isMobile ? 'auto' : '304px',
          }}
        >
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 3,
            }}
          >
            <Box sx={{ pt: isMobile ? 0 : 4, textAlign: 'center', mb: isMobile ? 3 : 0 }}>
              <Box
                component={People}
                sx={{
                  width: '48px',
                  height: '48px',
                  mb: isMobile ? 1 : 3,
                }}
              />
              <Typography fontWeight={500}>만 14세 이상 </Typography>
            </Box>
            <Button variant="contained" fullWidth onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); onNext(MemberKind.G14U); }}>가입하기</Button>
          </CardContent>
        </Card>

        {/* (국내거주)외국인 회원 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
            minHeight: isMobile ? 'auto' : '304px',
          }}
        >
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 3,
            }}
          >
            <Box sx={{ pt: isMobile ? 0 : 4, textAlign: 'center', mb: isMobile ? 3 : 0 }}>
              <Box
                component={Foreigner}
                sx={{
                  width: '48px',
                  height: '48px',
                  mb: isMobile ? 1 : 3,
                }}
              />
              <Typography fontWeight={500}>외국인 회원</Typography>
              <Typography variant="body2" color="text.secondary">(국내거주)</Typography>
            </Box>
            <Button variant="contained" fullWidth onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); onNext(MemberKind.FRNR); }}>가입하기</Button>
          </CardContent>
        </Card>
      </Stack>

      <Divider sx={{ mt: 9, typography: 'body2', color: 'text.secondary' }}>간편회원가입</Divider>

      {/* 간편회원가입 */}
      <Stack direction="row" spacing={5} alignContent="center" justifyContent="center" sx={{ mt: 6 }}>
        <IconButton
          onClick={() => snsAuth(MemberKind.KKO)}
          sx={{
            width: '48px',
            height: '48px',
            bgcolor: '#FEE500',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            '&:hover': {
              bgcolor: '#F2D900',
            }
          }}
        >
          <KakaoIcon />
        </IconButton>
        
        <IconButton
          onClick={() => {snsAuth(MemberKind.NVR)}}
          sx={{
            width: '48px',
            height: '48px',
            bgcolor: '#03C75A',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            '&:hover': {
              bgcolor: '#02B150',
            }
          }}
        >
          <NaverIcon />
        </IconButton>
        
        <IconButton
          onClick={() => {snsAuth(MemberKind.GGL)}}
          sx={{
            width: '48px',
            height: '48px',
            bgcolor: 'background.paper',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid',
            borderColor: 'divider',

            '&:hover': {
              bgcolor: 'grey.50',
            }
          }}
        >
          <GoogleIcon />
        </IconButton>
      </Stack>
    </Box>
  )
}